// Sorting and filtering sites for the Nearby strip and the list.
import { distanceM } from './geo.js';

/**
 * sites: [{ slug, name, address, category, lat, lon, ... }]
 * from: { lat, lon } or null. Returns new objects with `distance` (metres, or null when `from` is null).
 */
export function sortByDistance(sites, from) {
  const withD = sites.map((s) => ({ ...s, distance: from ? distanceM(from.lat, from.lon, s.lat, s.lon) : null }));
  return from
    ? withD.sort((a, b) => a.distance - b.distance)
    : withD.sort((a, b) => a.name.localeCompare(b.name));
}

const norm = (s) => String(s ?? '').normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** Case- and accent-insensitive match on name and address; empty categories set = all. */
export function filterSites(sites, { query = '', categories = new Set() } = {}) {
  const q = norm(query).trim();
  return sites.filter((s) => (!categories.size || categories.has(s.category))
    && (!q || norm(`${s.name} ${s.address}`).includes(q)));
}
